export default "__VITE_ASSET__ca126b10__"